import { configureStore,combineReducers } from "@reduxjs/toolkit";
import errorMessageReducer from "../reducer/errorMessageReducer";
import AlertMessaegReducer from "../reducer/alertReducer";
import { loginApi } from "../../services/apiService/login/login";
import { forgotPasswordApi } from "../../services/apiService/forgotpassword/forgotPassword"
import { signupApi } from "../../services/apiService/signup/signup";
import { bannerApi } from "../../services/apiService/banner/banner";
import { projectApi } from "../../services/apiService/projects/project";
import { leadsApi } from "../../services/apiService/leads/leads";
import { profileApi } from "../../services/apiService/profile/profile";

const rootReducer=combineReducers({
    ErrorMessageReducer:errorMessageReducer,
    AlertMessaegReducer:AlertMessaegReducer,
    [loginApi.reducerPath]:loginApi.reducer,
    [signupApi.reducerPath]:signupApi.reducer,
    [bannerApi.reducerPath]:bannerApi.reducer,
    [projectApi.reducerPath]:projectApi.reducer,
    [leadsApi.reducerPath]:leadsApi.reducer,
    [profileApi.reducerPath]:profileApi.reducer,
    [forgotPasswordApi.reducerPath]:forgotPasswordApi.reducer
})

const store=configureStore({
    reducer:rootReducer,
    middleware:(getdefaultMiddleware)=>
    getdefaultMiddleware().concat([
        loginApi.middleware,
        signupApi.middleware,
        bannerApi.middleware,
        projectApi.middleware,
        leadsApi.middleware,
        profileApi.middleware,
        forgotPasswordApi.middleware
    ])
})

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

